/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/query/react';
import { FILE_GENERATION_SERVICE } from 'utils/const';
import {
  generatePcdf,
  generateTaxImportFile,
  generateMvdf,
  generatePriceGuide,
  generateToolbox,
  generateVehicleTechSpecs,
  generatePfa,
  generateTopFeatures,
  generateFeaturesGuide,
} from './fileGenerationApis';

export const fileGenerationApi = createApi({
  reducerPath: 'fileGenerationApi',
  baseQuery: async (args) => {
    const { path } = args;
    switch (path) {
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_PCDF:
        return generatePcdf(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_TAX_IMPORT_FILE:
        return generateTaxImportFile(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_MVDF:
        return generateMvdf(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_PRICE_GUIDE:
        return generatePriceGuide(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_TOOLBOX:
        return generateToolbox(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_VEHICLE_TECH_SPECS:
        return generateVehicleTechSpecs(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_PFA:
        return generatePfa(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_TOP_FEATURES:
        return generateTopFeatures(args);
      case FILE_GENERATION_SERVICE.PATHS.GENERATE_FEATURES_GUIDE:
        return generateFeaturesGuide(args);
      default:
        return {
          error:
            'Redux >> FileGenerationApi: path attribute is missing in the arguments!',
        };
    }
  },
  endpoints: (builder) => ({
    generatePcdf: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_PCDF,
        ...args,
      }),
    }),
    generateTaxImportFile: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_TAX_IMPORT_FILE,
        ...args,
      }),
    }),
    generateMvdf: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_MVDF,
        ...args,
      }),
    }),
    generatePriceGuide: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_PRICE_GUIDE,
        ...args,
      }),
    }),
    generateToolbox: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_TOOLBOX,
        ...args,
      }),
    }),
    generateVehicleTechSpecs: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_VEHICLE_TECH_SPECS,
        ...args,
      }),
    }),
    generatePfa: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_PFA,
        ...args,
      }),
    }),
    generateTopFeatures: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_TOP_FEATURES,
        ...args,
      }),
    }),
    generateFeaturesGuide: builder.mutation({
      query: (args) => ({
        path: FILE_GENERATION_SERVICE.PATHS.GENERATE_FEATURES_GUIDE,
        ...args,
      }),
    }),
  }),
});

export const {
  useGeneratePcdfMutation,
  useGenerateTaxImportFileMutation,
  useGenerateMvdfMutation,
  useGeneratePriceGuideMutation,
  useGenerateToolboxMutation,
  useGenerateVehicleTechSpecsMutation,
  useGeneratePfaMutation,
  useGenerateTopFeaturesMutation,
  useGenerateFeaturesGuideMutation,
} = fileGenerationApi;
